<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>
                Commercial variants
            </h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new commercial variant"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">
                    All Commercial Chemicals
                </h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>
            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields"
                     :per-page="pagination.limit" :current-page="pagination.page"
                     :show-empty="true">

                <template slot="classification" slot-scope="data">
                    {{ data.item.classification ? data.item.classification.name : 'Unknown' }}
                </template>

                <template slot="hsr_number" slot-scope="data">
                    <a :href="data.item.hsr_link" target="_blank">
                        {{ data.item.hsr_number}}
                    </a>
                </template>

                <template slot="is_liquid" slot-scope="data">
                    {{ data.item.is_liquid ? 'Liquid' : 'Solid' }}
                </template>

                <template slot="activeIngredients" slot-scope="data">
                    <span class="badge-group mr-2" v-for="ingredient in [...data.item.activeIngredients].sort((a,b) => a.activeIngredient.name.localeCompare(b.activeIngredient.name))">
                        <span class="badge badge-secondary mb-1">{{ ingredient.activeIngredient.name }}</span>
                        <span class="badge badge-warning mb-1">{{ ingredient.ingredient_percentage }}%</span>
                    </span>
                </template>

                <template slot="cropTypes" slot-scope="data">
                    <span class="badge-group mr-2" v-for="cropType in [...data.item.cropTypes].sort((a,b) => a.cropType.name.localeCompare(b.cropType.name))">
                        <span class="badge badge-secondary mb-1">{{ cropType.cropType.name }}</span>
                        <span class="badge badge-purple mb-1 text-white">{{ cropType.recommended_rate }} mL</span>
                    </span>
                </template>

                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>

                <template slot="actions" slot-scope="row">
                    <b-button @click="showEditDialog(row.item)" variant="secondary btn--icon" v-b-tooltip.hover="'Edit Commercial variant'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" v-model="creating" :classifications="classifications" :cropTypeId="cropTypeId" v-if="creating" />
        <EditModal :close="closeEditDialog" v-model="editingCommercialVariant" :cropTypeId="cropTypeId"
                   :classifications="classifications" :commercial-variant="editingCommercialVariant" v-if="editingCommercialVariant" />
    </div>
</template>

<script>
import listClassificationsQuery from '@views/ChemicalCommercialVariants/Browse/queryListChemicalClassifications.graphql';
import listCommercialVariantsQuery from '@views/ChemicalCommercialVariants/Browse/queryListChemicalCommercialVariants.graphql';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseChemicalCommercialVariants',
  props: ['cropTypeId'],
  apollo: {
    commercialVariants: {
      query: listCommercialVariantsQuery,
      variables() {
        return {
          input: {
            include_deleted: true,
          },
        };
      },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.commercialVariants = data.filterChemicalCommercialVariants.data;
          this.pagination.total = data.filterChemicalCommercialVariants.meta.total;
        }
      },
    },
    classifications: {
      query: listClassificationsQuery,
      variables() {
        return {
          input: {
            include_deleted: true,
          },
        };
      },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.classifications = data.filterChemicalClassifications.data;
        }
      },
    },
  },
  data() {
    return {
      commercialVariants: [],
      classifications: [],
      editingCommercialVariant: null,
      creating: false,
      loading: 0,
      pagination: {
        page: 1,
        limit: this.$tableDefaultPageSize,
        total: 0,
      },
      table: {
        fields: [
          {
            key: 'name',
            label: 'Commercial variant',
            sortable: true,
          },
          {
            key: 'classification',
            label: 'Classification',
            sortable: false,
          },
          {
            key: 'activeIngredients',
            label: 'Active ingredients',
          },
          {
            key: 'cropTypes',
            label: 'Recommended Rate',
          },
          {
            key: 'is_liquid',
            label: 'Chemical State',
            sortable: true,
          },
          {
            key: 'hsr_number',
            label: 'HSR Number',
            sortable: true,
          },
          {
            key: 'un_number',
            label: 'UN number',
            sortable: true,
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      return (this.commercialVariants || []).map(item => ({ ...item }));
    },
  },
  methods: {
    showEditDialog(commercialVariant) {
      this.editingCommercialVariant = commercialVariant;
    },
    closeEditDialog() {
      this.editingCommercialVariant = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>